<template>
  <Medium
    v-model="fileUpload.file"
    :label="label"
    :aspect="aspect"
    :accepted-files="acceptedFiles"
    :thumbnail="thumbnail"
    :icon="icon"
    @click="fileUpload.open"
  />
</template>

<script lang="ts" setup>
import Medium from '@utils/inputs/Medium.vue';
import PhotoIcon from '@images/photo.svg?component';
import { watch } from 'vue';
import { useVModel } from '@vueuse/core';
import type { Props as MediumProps } from '@utils/inputs/Medium.vue';
import type { WbFile } from '@/entities/Entities';
import { useSingleFileUpload, type FileUpload } from '../upload/fileUpload';

interface Props /* extends MediumProps */ {
  modelValue?: FileUpload<WbFile>;
}

const props = withDefaults(defineProps<Props>(), { icon: PhotoIcon });
const emit = defineEmits(['update:modelValue']);

const internalValue = useVModel(props, 'modelValue', emit);

const fileUpload = useSingleFileUpload<WbFile>(internalValue);

watch(fileUpload.file, (val) => {
  internalValue.value = val;
});
</script>

<style lang="scss" scoped>

</style>
